import { Divider, DividerProps } from '@mui/material';
import React from 'react';

const DividerWrapper: React.FC<DividerProps> = (props) => <Divider {...props} role="none" />;

export default DividerWrapper;
